import { render } from "./MotivationTest.vue?vue&type=template&id=ee5c7e36&scoped=true"
import script from "./MotivationTest.vue?vue&type=script&lang=js"
export * from "./MotivationTest.vue?vue&type=script&lang=js"

import "./MotivationTest.vue?vue&type=style&index=0&id=ee5c7e36&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5c7e36"]])

export default __exports__